import React from "react";
import { Info, Shield, Clock, CheckCheck, ShieldX, ArrowRight, X } from "lucide-react";

const Instructions = ({ totalQuestions = 3, durationMinutes = 5, onStartQuiz, show=false, onClose,buttonTitle='Start Quiz' }) => {
  if (!show) return null;

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        backdropFilter: "blur(4px)",
        zIndex: 1100,
      }}
    >
      <div
        className="bg-white rounded-4 shadow-lg overflow-hidden"
        style={{ width: "100%", maxWidth: "520px", margin: "0 16px" }}
      >
        {/* Modal Header */}
        <div className="d-flex align-items-center justify-content-between px-4 py-3 border-bottom">
          <div className="d-flex align-items-center gap-2">
            <Info size={22} color="#3B7CF2" />
            <h5 className="fw-bold mb-0">Instructions</h5>
          </div>
          {onClose && (
            <button
              onClick={onClose}
              className="btn btn-link text-muted p-0 border-0"
              style={{ lineHeight: 1 }}
            >
              <X size={20} />
            </button>
          )}
        </div>

        {/* Modal Body */}
        <div className="px-4 py-4">
          {/* <p className="text-muted mb-4" style={{ fontSize: "14px", lineHeight: "1.6" }}>
            Please read the instructions carefully before starting the quiz. Once
            started, the timer cannot be paused and you must complete it in one
            session.
          </p> */}

          {/* Info Card */}
          <div
            className="rounded-3 p-3"
            style={{
              backgroundColor: "#f9fafb",
              border: "1px solid #e5e7eb",
            }}
          >
            <div className="d-flex flex-column gap-3">
              <div className="d-flex align-items-center gap-3">
                <Shield size={20} color="#198754" />
                <span className="fw-semibold" style={{ fontSize: "15px" }}>
                  {totalQuestions} Questions
                </span>
              </div>

              <div className="d-flex align-items-center gap-3">
                <Clock size={20} color="#198754" />
                <span className="fw-semibold" style={{ fontSize: "15px" }}>
                  {durationMinutes} Minutes limit
                </span>
              </div>

              <div className="d-flex align-items-center gap-3">
                <CheckCheck size={20} color="#198754" />
                <span className="fw-semibold" style={{ fontSize: "15px" }}>
                  Multiple choice questions
                </span>
              </div>

              <div className="d-flex align-items-center gap-3">
                <ShieldX size={20} color="#dc3545" />
                <span className="fw-semibold" style={{ fontSize: "15px", color: "#dc3545" }}>
                  No Save Allowed
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="px-4 py-3 border-top d-flex justify-content-center" style={{ backgroundColor: "#f9fafb" }}>
          <button
            onClick={onStartQuiz}
            className="btn btn-primary d-inline-flex align-items-center gap-2 px-4 py-2 fw-semibold"
            style={{ borderRadius: "8px",backgroundColor: "#081DA5", borderColor: "#081DA5" }}
          >
            {buttonTitle} <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Instructions;